module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "paddingless": "",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Custom",
      "component": _vm.ExFull,
      "code": _vm.ExFullCode,
      "paddingless": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Arrow",
      "component": _vm.ExArrow,
      "code": _vm.ExArrowCode,
      "paddingless": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Progress",
      "component": _vm.ExProgress,
      "code": _vm.ExProgressCode,
      "paddingless": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Indicator",
      "component": _vm.ExIndicator,
      "code": _vm.ExIndicatorCode,
      "paddingless": ""
    }
  }), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Custom Indicators",
      "component": _vm.ExCustomIndicator,
      "code": _vm.ExCustomIndicatorCode,
      "paddingless": ""
    }
  }, [_vm._v("\n            When images more than 6 add "), _c('code', [_vm._v("indicator-custom")]), _c('br'), _vm._v("\n            If want custom indicator to stay big, use "), _c('code', [_vm._v("is-medium")]), _vm._v(" on "), _c('code', [_vm._v("indicator-custom-size")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Switch like a gallery",
      "component": _vm.ExGallery,
      "code": _vm.ExGalleryCode,
      "paddingless": ""
    }
  }, [_c('p', [_vm._v("You may also want to add "), _c('code', [_vm._v("is-clipped")]), _vm._v(" modifier to a containing element (usually "), _c('code', [_vm._v("html")]), _vm._v(") to stop scroll overflow.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Carousel List",
      "component": _vm.ExCarouselList,
      "code": _vm.ExCarouselListCode,
      "paddingless": ""
    }
  }, [_c('p', [_vm._v("An imposing "), _c('strong', [_vm._v("carousel list")]), _vm._v(" to showcase viewer something.")]), _vm._v(" "), _c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.8.9")])])]), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Custom With Card",
      "component": _vm.ExWithCard,
      "code": _vm.ExWithCardCode,
      "paddingless": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Custom as an indicators",
      "component": _vm.ExWithList,
      "code": _vm.ExWithListCode,
      "paddingless": ""
    }
  }, [_c('p', [_vm._v("With "), _c('strong', [_vm._v("Breakpoint")]), _vm._v(" and "), _c('strong', [_vm._v("Switch like a Gallery")]), _vm._v(".")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('blockquote', [_vm._v("\n                Because images can take a few seconds to load (or not at all), use the "), _c('code', [_vm._v("image")]), _vm._v(" container to specify a "), _c('strong', [_vm._v("precisely sized")]), _vm._v("\n                container so that your layout isn't broken because of image loading or image errors - Bulma "), _c('a', {
    attrs: {
      "href": "https://bulma.io/documentation/elements/image/",
      "target": "_blank"
    }
  }, [_vm._v("image")]), _vm._v(".\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "has-text-centered"
  }, [_vm._v("Some source by "), _c('a', {
    attrs: {
      "href": "https://picsum.photos/",
      "target": "_blank"
    }
  }, [_vm._v("Picsum")]), _vm._v(" and Images from "), _c('a', {
    attrs: {
      "href": "https://unsplash.com/",
      "target": "_blank"
    }
  }, [_vm._v("Unsplash")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7b26826"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/carousel/Carousel.vue
// module id = 1337
// module chunks = 3